import { css, media, tokens } from '@sail/ui';
import { helmTokens } from '../../theme';
export const styles = {
    gridLines: css({
        position: 'absolute',
        width: '100%',
        height: '100%',
        top: 0,
        left: 0,
        paddingX: 'medium',
        pointerEvents: 'none'
    }),
    gridLinesContainer: css({
        display: 'grid',
        grid: '1fr/repeat(4,1fr)',
        position: 'relative',
        maxWidth: '1080px',
        height: '100%',
        margin: '0 auto'
    }),
    gridLine: css({
        width: '1px',
        // TODO: Replace with color with token?
        backgroundImage: `linear-gradient(180deg, ${helmTokens.color.gridLines.dashed}, ${helmTokens.color.gridLines.dashed} 50%,transparent 0,transparent)`,
        backgroundSize: '1px 8px',
        ':first-of-type': {
            backgroundImage: 'none',
            backgroundColor: helmTokens.color.gridLines.solid
        },
        ':last-of-type': {
            position: 'absolute',
            top: 0,
            right: 0,
            height: '100%',
            backgroundImage: 'none',
            backgroundColor: helmTokens.color.gridLines.solid
        },
        [media.down(tokens.viewport.medium)]: {
            ':nth-of-type(2n)': {
                visibility: 'hidden'
            }
        },
        [media.down(tokens.viewport.small)]: {
            ':nth-of-type(3n)': {
                visibility: 'hidden'
            }
        }
    })
};

//# sourceMappingURL=GridLinesStyles.js.map